// extracted by mini-css-extract-plugin
module.exports = {"partnerClass":"index_partnerClass__jQvuh","imgWrapperClass":"index_imgWrapperClass__oX0O9","partnerAnimation":"index_partnerAnimation__MVbNj"};